module.exports = __webpack_public_path__ + "img/Inteligo.ddad6066.png";